import { Button } from 'blaze-ui/Button'
import { LinkAngled } from 'blaze-ui/icons/20'
import { AddWebpageModal } from './AddWebpageModal'
import { ButtonProps } from 'blaze-ui/Button/Types'
import { Source } from 'types'
import { ModalTrigger } from 'almanac-ui/Modal/ModalTrigger'

export interface AddWebpageButtonProps extends Omit<ButtonProps, 'onPress'> {
  onSourceCreated?: (source: Source, saveMedia?: boolean) => Promise<any> | void,
  primaryAction?: string
}

export const AddWebpageButton = ({ variant = 'secondary', onSourceCreated, primaryAction, children, ...buttonProps }: AddWebpageButtonProps) => {
  return (
    <ModalTrigger modal={AddWebpageModal} onSourceCreated={onSourceCreated} options={{ newStack: true }} primaryAction={primaryAction}>
      <Button variant={variant} frontIcon={LinkAngled} {...buttonProps}>
        {children ?? 'Add Webpage'}
      </Button>
    </ModalTrigger>
  )
}
